











import Component from 'vue-class-component';

import UiPageHeader from '@/components/ui/UiPageHeader.vue';

import { BaseVue } from '../../BaseVue';
import API from '../../components/org/API.vue';

@Component({
  components: {
    API,
    UiPageHeader,
  },
})
export default class APIClass extends BaseVue {
  public selectedTab = 0;
}
